import React from "react";
import AudioTest from "../audioVisualizer";
import { Row } from "reactstrap";
import SimpleButton from "../../components/buttons/SimpleButton";
import { SpeakerTest } from "../speakerTest/SpeakerTest";
import { BrowserCompatibility } from "../browserCompatibility/BrowserCompatibility";
import { NetWorkSpeedTest } from "../networkSpeedTest/NetWorkSpeedTest";
import { browserName, browserVersion } from "react-device-detect";
import { exerciseType } from "../../components/constants/constants";
import { includes } from "lodash";

const SystemModal = ({ data, onClick,toggle, setAssessmentStarted, isSpeaktest }) => {
    const arr = []
    // eslint-disable-next-line no-lone-blocks
    {data &&
        data.sections &&
        data.sections.map((section) => (
            section &&
            section.pages.map((page) => (
                page &&
                page.exercises.map((exercise) => {
                    if (!arr.includes(exercise.task_type))
                    {
                        arr.push(exercise.task_type)
                    }
                }
            )
            )
      )))};
      let mainClass,speakerClass
      if(includes(arr, exerciseType.PRONUNCIATION_TASK) || includes(arr, exerciseType.SPEAKING_TASK))
        {
            mainClass = "py-0";
            speakerClass = "pb-0";
        }
        else {
            mainClass = "py-3";
            speakerClass = "";
        }
      
  return (
    <div>
        <div className={`smp-5 px-4 col-12 ${mainClass}`}>
            <BrowserCompatibility browserName={browserName} browserVersion={browserVersion}  />
            <NetWorkSpeedTest requirementdata="system requirement" arr={arr} />
            {includes(arr, exerciseType.PRONUNCIATION_TASK) || includes(arr, exerciseType.SPEAKING_TASK) ? (
                <AudioTest  />
            ):null}
            <SpeakerTest speakerClass={speakerClass} />

        </div>
        <Row className="px-4 pt-3 gx-0">
        <div className="align-text sm-pe-4 d-flex justify-content-end">
            {!isSpeaktest && (
                <button
                type="button"
                class="btn p-0 text-dark border-bottom-dark me-4"
                onClick={() => {
                    setAssessmentStarted(true);
                    toggle();
                }}
                >
                Skip for now
                </button>
            )}
            <SimpleButton
            label={"Next"}
            data-tc="system-modal"
            className="btn btn-warning px-3 py-1"
            onClick={() => {
                onClick(3);
            }}
            />
        </div>
        </Row>
    </div>
  );
};



export default SystemModal;